import { render, staticRenderFns } from "./MsupplierView.vue?vue&type=template&id=1c0b728a&scoped=true"
import script from "./MsupplierView.vue?vue&type=script&lang=js"
export * from "./MsupplierView.vue?vue&type=script&lang=js"
import style0 from "./MsupplierView.vue?vue&type=style&index=0&id=1c0b728a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b728a",
  null
  
)

export default component.exports